import { Pagination } from 'antd';
import style from './PostsList.module.css';
import { useEffect, useMemo, useRef, useState } from 'react';
import SEOHelmet from '../../SEO/SEOHelmet';

import { useParams } from 'react-router-dom';
import { getTranslation, normalizeLang } from '../../../helpers/translation';
import { deletePost, getAllPosts } from '../../../api/postsApi';
import BlogPostItem from '../BlogPostItem/BlogPostItem';

const PostsList = ({}) => {
  const { lang: rawLang } = useParams();
  const lang = normalizeLang(rawLang);
  const t = useMemo(() => getTranslation(lang), [lang]);

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const topRef = useRef(null);

  useEffect(() => {
    setPage(1);
  }, [lang]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getAllPosts({
      page,
      limit,
      sort: '-createdAt',
      language: lang || 'en',
    })
      .then(data => {
        if (cancelled) return;
        const nTotal = Number(data?.total ?? 0);
        const nLimit = Number(data?.limit ?? limit);
        const nPages = Number(
          data?.pages ?? Math.max(1, Math.ceil(nTotal / Math.max(1, nLimit))),
        );
        setItems(data?.items || []);
        setTotal(nTotal);
        setLimit(nLimit);
        setPages(nPages);
        console.log('BlogPage API ->', {
          page,
          nTotal,
          nLimit,
          nPages,
          count: (data?.items || []).length,
        });
      })
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [lang, page, limit]);

  const handlePageChange = (nextPage, nextPageSize) => {
    setPage(nextPage);
    if (nextPageSize && nextPageSize !== limit) setLimit(nextPageSize);
    topRef.current
      ? topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      : window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = id => {
    deletePost(id).then(() => {
      const filtered = items.filter(el => el._id !== id);
      setItems(filtered);
    });
  };

  return (
    <div className={style.blogContainer} ref={topRef}>
      <SEOHelmet pageKey="blog" />

      <h1>{t.header.blogLink || 'Admin Blog Posts list '}</h1>
      <Pagination
        current={page}
        total={Math.max(total, 1)}
        pageSize={limit}
        onChange={handlePageChange}
        align="center"
        className={style.pagination} // тільки для відступів/стилів
        showSizeChanger={false}
      />

      <div className={style.wrapContainer}>
        {loading && items.length === 0 ? (
          <div style={{ padding: '24px 0', opacity: 0.8 }}>Loading…</div>
        ) : items.length > 0 ? (
          items.map(el => (
            <BlogPostItem
              key={el._id}
              info={el}
              handleDelete={() => handleDelete(el._id)}
            />
          ))
        ) : (
          <div style={{ padding: '24px 0', opacity: 0.8 }}>No posts yet.</div>
        )}
      </div>

      {/* Пагінація — показуємо завжди для перевірки.
          Коли все ОК, можеш додати hideOnSinglePage або умову. */}
      <Pagination
        current={page}
        total={Math.max(total, 1)}
        pageSize={limit}
        onChange={handlePageChange}
        align="center"
        className={style.pagination} // тільки для відступів/стилів
        showSizeChanger={false}
      />
    </div>
  );
};

export default PostsList;
